import { Navigate } from 'react-router-dom'
import { useAuth } from '@/auth/useAuth'
import type { ReactNode } from 'react'

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, token, loading } = useAuth()

  if (loading) {
    return <div style={{ padding: 32, color: '#666' }}>Loading...</div>
  }

  if (!token || !user) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}
